import { Schema, model, Types, models } from "mongoose";
import { IOwner } from "./types";

const ownerSchema = new Schema<IOwner>(
  {
    chainId: { type: Number, required: true },
    treasury: { type: String, default: "" },
    lock: { type: String, default: "" },
    mainRouter: { type: String, default: "" },
  },
  {
    toObject: {
      getters: true,
      versionKey: false,
      transform: (doc, ret: any) => {
        ret.id = ret._id.toString();
        delete ret._id;
      },
    },
  }
);

ownerSchema.index({ chainId: 1 });

export const OwnerModel = models?.Owner || model<IOwner>("Owner", ownerSchema);
